// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".feature-select-point[data-v-57e6621e]{background:radial-gradient(99.31% 370.02% at .69% 1.34%,rgba(49,175,186,.1) 0,rgba(97,219,230,.1) 100%);border:1px solid #dee1e6;border-radius:20px;text-align:start}.point-card-title[data-v-57e6621e]{background:radial-gradient(99.31% 370.02% at .69% 1.34%,#31afba 0,#61dbe6 100%);-webkit-background-clip:text;-webkit-text-fill-color:transparent}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
